import type { PostmarkTemplateInput } from './types';

/** Sample inner HTML injected at layout {{{@content}}}. */
export const LAYOUT_PREVIEW_SAMPLE_HTML = [
  '<p style="margin:0 0 14px;font-size:16px;line-height:1.6;color:#1f2937;">',
  '<strong>Thanks for coming.</strong> Sample body inside this layout.',
  '</p>',
  '<p style="margin:0;font-size:16px;line-height:1.6;color:#475569;">',
  'Merge fields like {{name}} show as Preview Reader on send.',
  '</p>',
].join('');

const SAMPLE_BODY_HTML = [
  '<p style="margin:0 0 14px;font-size:16px;line-height:1.6;color:#1f2937;">',
  '<strong>Sample newsletter body.</strong> On send, {{{body_html}}} is replaced with rendered blocks.',
  '</p>',
].join('');

const SAMPLE_VARS: Record<string, string> = {
  subject: 'Template preview',
  subtitle: 'Sample preheader for inbox preview',
  email: 'preview@example.com',
  name: 'Preview Reader',
  first_name: 'Preview',
  scheduled_email_id: '00000000-0000-0000-0000-000000000000',
  body_html: SAMPLE_BODY_HTML,
};

/** Client-side HTML preview — no Postmark API (mustache vars are approximated). */
export function buildLocalPostmarkPreviewHtml(input: PostmarkTemplateInput): string | null {
  const raw = input.htmlBody?.trim();
  if (!raw) return null;

  let html = raw;

  if (input.templateType === 'Layout') {
    html = html.replace(/\{\{\{@content\}\}\}/g, LAYOUT_PREVIEW_SAMPLE_HTML);
  }

  for (const [key, value] of Object.entries(SAMPLE_VARS)) {
    html = html.split(`{{{${key}}}}`).join(value);
    html = html.split(`{{${key}}}`).join(value);
  }

  return html;
}

/** Shared min-heights for template editor textareas and preview iframes. */
export const POSTMARK_EDITOR_TEXTAREA_CLASS =
  'w-full min-h-[min(70vh,720px)] px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm font-mono focus:outline-none focus:ring-2 focus:ring-emerald-500 resize-y';

export const POSTMARK_PREVIEW_IFRAME_CLASS =
  'w-full min-h-[min(75vh,780px)] border-0 bg-white';

export const POSTMARK_PREVIEW_PANEL_CLASS =
  'rounded-xl border border-gray-200 dark:border-gray-700 bg-gray-100 dark:bg-gray-900/50 overflow-hidden min-h-[min(75vh,780px)]';
